/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { Card } from '@/components/uikit';
import { Grid } from '@material-ui/core';
import { useTranslate } from '@/locale';
import { GetOrderStatusInterface, SubscriptionStatusString } from '@/types';

interface StatusListBarProps {
  orderStatus: GetOrderStatusInterface[];
}

type MapToStatusColor = {
  [key in SubscriptionStatusString]?:
    | 'text-green'
    | 'text-yellow'
    | 'text-navy'
    | 'text-red';
};

type mapStatusToText = {
  [key in SubscriptionStatusString]?: string;
};

const StatusListBar = (props: StatusListBarProps) => {
  const { orderStatus } = props;
  const { translate } = useTranslate();
  const mapStatusColor: MapToStatusColor = {
    in_review: 'text-yellow',
    pending_address: 'text-navy',
    prescription_approved: 'text-green',
    prescription_rejected: 'text-red',
    payment_order: 'text-navy',
    payment_successful: 'text-green',
    payment_expired: 'text-red',
    payment_failed: 'text-red',
    order_processed: 'text-navy',
    order_cancelled: 'text-red',
    waiting_for_payment: 'text-yellow',
    waiting_for_pickup: 'text-navy',
    picked_up: 'text-navy',
    on_delivery: 'text-navy',
    delivered: 'text-green',
    delivery_failed: 'text-red',
    active: 'text-green',
    inactive: 'text-green',
  };

  const mapStatusToText: mapStatusToText = {
    in_review: translate('inReview'),
    pending_address: translate('pendingAddressTitle'),
    prescription_approved: translate('prescriptionApprovedTitle'),
    prescription_rejected: translate('prescriptionRejected'),
    payment_order: translate('paymentOrderTitle'),
    payment_successful: translate('paymentSuccessfulTitle'),
    payment_expired: translate('paymentExpiredTitle'),
    payment_failed: translate('paymentFailedTitle'),
    order_processed: translate('orderProcessed'),
    order_cancelled: translate('orderCanceled'),
    waiting_for_payment: translate('waitingForPaymentTitle'),
    waiting_for_pickup: translate('waitingForPickup'),
    picked_up: translate('pickedUp'),
    on_delivery: translate('onDelivery'),
    delivered: translate('delivered'),
    delivery_failed: translate('deliveryFailed'),
    active: translate('active'),
    inactive: translate('inActive'),
  };

  const checkStatusMapping: (
    status: SubscriptionStatusString
  ) => SubscriptionStatusString = status => {
    if (status === 'active' || status === 'inactive') {
      return 'delivered';
    }
    return status;
  };

  return (
    <Card className="status-list-bar">
      <Grid>
        <Grid
          style={{
            backgroundColor: 'rgb(22,45,100)',
          }}
          className="bordered-bottom dis-flex"
        >
          <Grid className="flex-center bordered-right flex-1 py-14 px-14">
            <span className="text-title">{translate('patient')}</span>
          </Grid>
          <Grid className="flex-center flex-1 py-14 px-14">
            <span className="text-title">Status</span>
          </Grid>
        </Grid>
        {orderStatus.map(each => (
          <Grid className="bordered-bottom dis-flex">
            <Grid className="flex-center bordered-right flex-1 py-14 px-14">
              <span className="text text-center">{each.patient_name}</span>
            </Grid>
            <Grid className="flex-center flex-1 py-14 px-14">
              <span
                className={`text text-center ${
                  mapStatusColor[checkStatusMapping(each.status)]
                }`}
              >
                {mapStatusToText[checkStatusMapping(each.status)]}
              </span>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
};

export default StatusListBar;
